<template>
  <v-container>
    <v-container>
      <v-sheet>
        <v-card-title>{{ $t("gamesTitle") }}</v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">#</th>
                <th class="text-left">{{ $t("gamesName") }}</th>
                <th class="text-left">{{ $t("gamesGenre") }}</th>
                <th class="text-left">{{ $t("gamesRestriction") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(game, k) in location.available_games" :key="game.id">
                <td>{{ k + 1 }}</td>
                <td>{{ game.name }}</td>
                <td>{{ game.genre }}</td>
                <td v-if="gameRestrict(game.info)">
                  {{ gameRestrict(game.info) }}
                </td>
                <td v-else style="color: red">
                  {{ $t("gamesAgeNotSpecified") }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "GamesTable",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  computed: {
    ...mapGetters(["location"]),
  },

  methods: {
    gameRestrict: function (gameInfo) {
      const restrict = gameInfo.find((el) => {
        return el.country === this.location.country.id;
      });
      if (restrict) {
        return restrict.age + "+";
      }
    },
  },
};
</script>
